import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope, FaArrowUp, FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { animateScroll as scroll } from "react-scroll";

export default function Footer() {
  const scrollToTop = () => scroll.scrollToTop();

  return (
    <footer className="text-white mt-auto" style={{ backgroundColor: '#10495e' }}>
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-2 md:px-4 py-6 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">

          {/* Company Info */}
          <div className="space-y-2 md:space-y-4 col-span-2 md:col-span-1">
            <h3 className="text-sm md:text-xl font-bold text-cyan-300">Home Cure</h3>
            <p className="text-xs md:text-base text-gray-200 leading-relaxed hidden md:block">
              Your trusted healthcare partner, delivering medicines and medical services right to your doorstep.
            </p>
            <p className="text-xs text-gray-200 leading-tight md:hidden">
              Healthcare at your doorstep
            </p>
            <div className="flex space-x-1 md:space-x-3">
              <a href="https://facebook.com/homecure" target="_blank" rel="noopener noreferrer"
                 className="w-6 h-6 md:w-8 md:h-8 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110"
                 style={{ backgroundColor: '#0d3b4a' }}>
                <FaFacebookF className="w-3 h-3 md:w-4 md:h-4 text-blue-400" />
              </a>
              <a href="https://twitter.com/homecure" target="_blank" rel="noopener noreferrer"
                 className="w-6 h-6 md:w-8 md:h-8 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110"
                 style={{ backgroundColor: '#0d3b4a' }}>
                <FaTwitter className="w-3 h-3 md:w-4 md:h-4 text-sky-400" />
              </a>
              <a href="https://instagram.com/homecure" target="_blank" rel="noopener noreferrer"
                 className="w-6 h-6 md:w-8 md:h-8 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110"
                 style={{ backgroundColor: '#0d3b4a' }}>
                <FaInstagram className="w-3 h-3 md:w-4 md:h-4 text-pink-400" />
              </a>
              <a href="https://linkedin.com/company/homecure" target="_blank" rel="noopener noreferrer"
                 className="w-6 h-6 md:w-8 md:h-8 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110"
                 style={{ backgroundColor: '#0d3b4a' }}>
                <FaLinkedinIn className="w-3 h-3 md:w-4 md:h-4 text-blue-300" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-2 md:space-y-4">
            <h4 className="text-sm md:text-lg font-semibold text-cyan-300">Quick Links</h4>
            <ul className="space-y-1 md:space-y-2">
              <li><a href="/" className="text-xs md:text-base text-gray-200 hover:text-cyan-300 transition-colors">Home</a></li>
              <li><a href="/Medicines" className="text-xs md:text-base text-gray-200 hover:text-cyan-300 transition-colors">Medicines</a></li>
              <li><a href="/medical-tests" className="text-xs md:text-base text-gray-200 hover:text-cyan-300 transition-colors">Tests</a></li>
              <li><a href="/online-consultation" className="text-xs md:text-base text-gray-200 hover:text-cyan-300 transition-colors">Consult</a></li>
              <li><a href="/about" className="text-xs md:text-base text-gray-200 hover:text-cyan-300 transition-colors">About</a></li>
            </ul>
          </div>

          {/* Legal & Policies */}
          <div className="space-y-2 md:space-y-4">
            <h4 className="text-sm md:text-lg font-semibold text-cyan-300">Policies</h4>
            <ul className="space-y-1 md:space-y-2">
              <li><a href="/contact-us" className="text-xs md:text-base text-gray-200 hover:text-cyan-300 transition-colors">Contact Us</a></li>
              <li><a href="/terms-and-conditions" className="text-xs md:text-base text-gray-200 hover:text-cyan-300 transition-colors">Terms & Conditions</a></li>
              <li><a href="/privacy-policy" className="text-xs md:text-base text-gray-200 hover:text-cyan-300 transition-colors">Privacy Policy</a></li>
              <li><a href="/shipping-policy" className="text-xs md:text-base text-gray-200 hover:text-cyan-300 transition-colors">Shipping Policy</a></li>
              <li><a href="/cancellations-and-refunds" className="text-xs md:text-base text-gray-200 hover:text-cyan-300 transition-colors">Refunds</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-2 md:space-y-4 col-span-2 md:col-span-1">
            <h4 className="text-sm md:text-lg font-semibold text-cyan-300">Contact</h4>
            <div className="space-y-2 md:space-y-3">
              <div className="flex items-start space-x-1 md:space-x-3">
                <FaEnvelope className="w-3 h-3 md:w-4 md:h-4 text-cyan-300 mt-0.5 md:mt-1 flex-shrink-0" />
                <span className="text-xs md:text-base text-gray-200 break-all">Homecureexpress@gmail.com</span>
              </div>
              <div className="flex items-start space-x-1 md:space-x-3">
                <FaPhoneAlt className="w-3 h-3 md:w-4 md:h-4 text-cyan-300 mt-0.5 md:mt-1 flex-shrink-0" />
                <span className="text-xs md:text-base text-gray-200">+91 98765 43210</span>
              </div>
              <div className="flex items-start space-x-1 md:space-x-3">
                <FaMapMarkerAlt className="w-3 h-3 md:w-4 md:h-4 text-cyan-300 mt-0.5 md:mt-1 flex-shrink-0" />
                <span className="text-xs md:text-base text-gray-200">Patna, Bihar</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t" style={{ borderColor: '#0d3b4a' }}>
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
            <div className="text-center md:text-left">
              <p className="text-xs md:text-sm text-gray-300">
                © {new Date().getFullYear()} Home Cure Express. All rights reserved.
              </p>
              <p className="text-xs md:text-sm text-gray-300">
                Managed by{" "}
                <a
                  href="https://www.anviom.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-cyan-300 hover:text-cyan-200 transition-colors"
                >
                  Anviom
                </a>
              </p>
            </div>
            
            {/* Scroll to Top Button */}
            <button
              onClick={scrollToTop}
              className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-cyan-300 focus:ring-offset-2"
              style={{ 
                backgroundColor: '#0d3b4a',
                focusRingOffsetColor: '#10495e'
              }}
              aria-label="Scroll to top"
            >
              <FaArrowUp className="w-4 h-4 text-cyan-300" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

